<template>
  <div>
    <v-autocomplete
      ref="autocompleteCmp"
      :dense="dense"
      :hide-details="hideDetails"
      v-model="time"
      prepend-icon="mdi-clock-outline"
      auto-select-first
      :label="label"
      item-text="formattedTime"
      item-value="formattedTime"
      :items="timePurposes"
      :hint="hint"
      @change="onChange"
      @blur="onBlur"
      :disabled="disabled"
    >
    </v-autocomplete>
  </div>
</template>
<script>
export default {
  name: 'TimePicker',
  props: {
    value: {
      required: false
    },
    label: {
      required: false,
      default: null
    },
    dense: {
      required: false,
      default: null
    },
    hideDetails: {
      required: false,
      default: null
    },
    hint: {
      required: false,
      default: '(H)H:MM'
    },
    disabled: {
      required: false,
      default: false
    },
    showListOnMounted: {
      required: false,
      default: false
    }
  },
  data () {
    return {
      updateKey: 0,
      timePurposes: [
        {
          formattedTime: '00:00'
        },
        {
          formattedTime: '00:30'
        },
        {
          formattedTime: '01:00'
        },
        {
          formattedTime: '01:30'
        },
        {
          formattedTime: '02:00'
        },
        {
          formattedTime: '02:30'
        },
        {
          formattedTime: '03:00'
        },
        {
          formattedTime: '03:30'
        },
        {
          formattedTime: '04:00'
        },
        {
          formattedTime: '04:30'
        },
        {
          formattedTime: '05:00'
        },
        {
          formattedTime: '05:30'
        },
        {
          formattedTime: '06:00'
        },
        {
          formattedTime: '06:30'
        },
        {
          formattedTime: '07:00'
        },
        {
          formattedTime: '07:30'
        },
        {
          formattedTime: '08:00'
        },
        {
          formattedTime: '08:30'
        },
        {
          formattedTime: '09:00'
        },
        {
          formattedTime: '09:30'
        },
        {
          formattedTime: '10:00'
        },
        {
          formattedTime: '10:30'
        },
        {
          formattedTime: '11:00'
        },
        {
          formattedTime: '11:30'
        },
        {
          formattedTime: '12:00'
        },
        {
          formattedTime: '12:30'
        },
        {
          formattedTime: '13:00'
        },
        {
          formattedTime: '13:30'
        },
        {
          formattedTime: '14:00'
        },
        {
          formattedTime: '14:30'
        },
        {
          formattedTime: '15:00'
        },
        {
          formattedTime: '15:30'
        },
        {
          formattedTime: '16:00'
        },
        {
          formattedTime: '16:30'
        },
        {
          formattedTime: '17:00'
        },
        {
          formattedTime: '17:30'
        },
        {
          formattedTime: '18:00'
        },
        {
          formattedTime: '18:30'
        },
        {
          formattedTime: '19:00'
        },
        {
          formattedTime: '19:30'
        },
        {
          formattedTime: '20:00'
        },
        {
          formattedTime: '20:30'
        },
        {
          formattedTime: '21:00'
        },
        {
          formattedTime: '21:30'
        },
        {
          formattedTime: '22:00'
        },
        {
          formattedTime: '22:30'
        },
        {
          formattedTime: '23:00'
        },
        {
          formattedTime: '23:30'
        }
      ]
    }
  },
  computed: {
    time: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  mounted () {
    if (this.showListOnMounted) {
      this.$refs.autocompleteCmp.$refs.input.focus()
      this.$refs.autocompleteCmp.isMenuActive = true
    }
  },
  methods: {
    onChange (e) {
      const isTimeValid = this.processFormattedTimeDuration(e)
      if (isTimeValid) {
        this.$emit('change', e)
      } else {
        this.$store.dispatch('setError', { errorMsg: 'Duration fields must be in (H)H:MM format, positive and less than 12:00' })
      }
    },
    onBlur (e) {
      const value = e.target.value
      for (let i = 0; i < this.timePurposes.length; i++) {
        if (this.timePurposes[i].formattedTime.search(value) > -1) {
          this.time = this.timePurposes[i].formattedTime
          break
        }
      }
      this.$emit('blur', e)
    },
    processFormattedTimeDuration (formattedTimeDuration) {
      const regExpEvent = new RegExp('^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$', 'gi')
      return formattedTimeDuration.match(regExpEvent)
    }
  }
}
</script>
